module.exports = __webpack_public_path__ + "static/img/title-banner1-type1.b1cff2f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/4/title-banner1-type1.png
// module id = nMVq
// module chunks = 1